import { z } from 'zod';
import { UseSchema } from '../../common';

export const projectAccessControlPolicyPasswordUpdateDtoSchema = z.object({
  password: z.string().min(6).max(255).nullable().describe('Access control policy password'),
});

@UseSchema(projectAccessControlPolicyPasswordUpdateDtoSchema)
export class ProjectAccessControlPolicyUpdatePasswordDto {}
export interface ProjectAccessControlPolicyUpdatePasswordDto extends z.input<
  typeof projectAccessControlPolicyPasswordUpdateDtoSchema
> {}
